<template>
  <div class="row">
    <div class="col-12">
      <div class="top__header">
        <span class="back" @click="back()">
          <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M15.7071 5.79289C16.0976 6.18342 16.0976 6.81658 15.7071 7.20711L10.4142 12.5L15.7071 17.7929C16.0976 18.1834 16.0976 18.8166 15.7071 19.2071C15.3166 19.5976 14.6834 19.5976 14.2929 19.2071L8.29289 13.2071C7.90237 12.8166 7.90237 12.1834 8.29289 11.7929L14.2929 5.79289C14.6834 5.40237 15.3166 5.40237 15.7071 5.79289Z"
              fill="black"
            />
          </svg>
        </span>
        <div>
          <span style="font-weight: bold; font-size: 16px"
            >Assurance multirisque habitation</span
          >
          <span
            v-if="subscription.status === 'add'"
            class="badge badge-pill badge-info"
            >Paiement à la livraison</span
          >
          <span
            v-if="
              subscription.status === 'negotiated' &&
              subscription.amount_negotiated !== null
            "
            class="badge badge-pill badge-info"
            >Négocié</span
          >
          <span
            v-if="subscription.status === 'paid'"
            class="badge badge-pill badge-success"
            >Payé</span
          >
          <span
            v-if="
              subscription.status === 'negotiated' &&
              subscription.amount_negotiated === null
            "
            class="badge badge-pill badge-info"
            >En négociation</span
          >
          <span
            v-if="subscription.status === 'save'"
            style="color: #0b2e13"
            class="badge badge-pill badge-light"
            >Sauvegardé</span
          >
        </div>
        <div style="place-self: end">
          <button
            @click="addBasket"
            v-if="
              subscription.status === 'negotiated' &&
              subscription.amount_negotiated !== null
            "
            class="btn btn-primary btn-xs"
          >
            Ajouter au panier
          </button>
          <button
            @click="showComments"
            class="btn btn-secondary btn-xs"
            v-if="
              subscription.status === 'negotiated' &&
              subscription.amount_negotiated === null
            "
          >
            Rentrer en contact avec un commercial
          </button>
          <a
            v-if="subscription.status === 'save'"
            href="#"
            @click.prevent="continousAction"
            class="btn btn-primary"
            >Poursuivre</a
          >
          <a
            v-if="subscription.status === 'paid'"
            :href="'/api/subscriptions/' + subscription.uuid + '/invoice'"
            target="_blank"
            class="btn btn-outline-success btn-xs ml-1"
          >
            Télécharger Facture
          </a>
        </div>
      </div>
      <div class="card__info">
        <h4>Informations client</h4>
        <div class="__first">
          <div>
            <div><strong>Nom</strong></div>
            <span>{{
              subscription.data ? subscription.data.client_name : ""
            }}</span>
          </div>
          <div>
            <div><strong>Prénom(s)</strong></div>
            <span>{{
              subscription.data ? subscription.data.client_firstname : ""
            }}</span>
          </div>
          <div>
            <div><strong>Téléphone</strong></div>
            <span>{{ subscription.user ? subscription.user.phone : "" }}</span>
          </div>
        </div>
        <div class="__first mt-2">
          <div>
            <div><strong>Email</strong></div>
            <span>{{ subscription.user ? subscription.user.email : "" }}</span>
          </div>
          <div>
            <div><strong>Adresse</strong></div>
            <span>{{
              subscription.user ? subscription.user.address : ""
            }}</span>
          </div>
          <div>
            <div><strong>Personne à contacter en cas d’urgence</strong></div>
            <span>
              {{
                subscription.user.contact_person_full_name
                  ? subscription.user.contact_person_full_name
                  : ""
              }}
              {{
                subscription.user.contact_person_number
                  ? " (" + subscription.user.contact_person_number + ")"
                  : ""
              }}
            </span>
          </div>
        </div>
      </div>
      <div class="card__info mt-2">
        <h4>Informations de souscription</h4>
        <div class="__first">
          <div>
            <div><strong>Produit</strong></div>
            <span>{{
              subscription.product ? subscription.product.name : ""
            }}</span>
          </div>
          <div>
            <div><strong>Montant (Fcfa)</strong></div>
            <span>{{ subscription ? $format(subscription.amount) : "" }}</span>
          </div>
          <div>
            <div><strong>Date de souscription</strong></div>
            <span>{{ subscription ? subscription.created_at : "" }}</span>
          </div>
        </div>
      </div>
      <div class="card__info mt-2">
        <h4>Formulaire de souscription</h4>
        <div class="__first mt-2">
          <div>
            <div><strong>Activité/Profession</strong></div>
            <span>{{ subscription.data.activity }}</span>
          </div>
          <div>
            <div><strong>Etes-vous propriétaire du bâtiment ?</strong></div>
            <span>{{
              subscription.data.owner_of_the_building ? "Oui" : "Non"
            }}</span>
          </div>
          <div>
            <div><strong>Etes-vous locataire du bâtiment ?</strong></div>
            <span>{{ subscription.data.building_tenant ? "Oui" : "Non" }}</span>
          </div>
          <div class="mt-2">
            <div><strong>Adresse</strong></div>
            <span>{{ subscription.data.address ?? "" }}</span>
          </div>
        </div>
        <div class="mt-2">
          <p>
            <strong
              >Prière faire une brève description de votre bâtiment (niveaux,
              matériaux, types de construction)</strong
            >
          </p>
          <p>
            {{
              subscription.data.description_of_the_building
                ? subscription.data.description_of_the_building
                : ""
            }}
          </p>
        </div>
        <!-- Matériel et mobilier -->
        <hr />
        <div class="mt-2">
          <h4>Matériel et mobilier</h4>
          <div class="mt-1">
            <h6>Avez-vous du matériel et mobilier ?</h6>
            <div>
              {{
                subscription.data.do_you_have_equipment_and_furniture
                  ? "Oui"
                  : "Non"
              }}
            </div>
          </div>
          <div class="mt-1">
            <h6>Y-a-t-il des vitres ?</h6>
            <div>
              {{
                subscription.data.is_window_exist && subscription.data.is_window_exist
                  ? "Oui"
                  : "Non"
              }}
            </div>
          </div>
          <div class="mt-1">
            <h6>Des lames Naco ?</h6>
            <div>
              {{
                subscription.data.is_naco_exist && subscription.data.is_naco_exist
                  ? "Oui"
                  : "Non"
              }}
            </div>
          </div>
        </div>
        <div class="__first mt-2">
          <div>
            <div>
              <strong>Liste détaillée des matériels et mobiliers</strong>
            </div>
            <div>
              {{
                subscription.data.detailed_list_of_equipment_and_furniture
                  ? subscription.data.detailed_list_of_equipment_and_furniture
                  : ""
              }}
            </div>
          </div>
          <div class="mt-2">
            <div class="mt-2"><strong>Montant</strong></div>
            <div>
              {{
                subscription.data.amount_equipment_and_furniture
                  ? subscription.data.amount_equipment_and_furniture
                  : ""
              }}
            </div>
          </div>
        </div>
        <!-- Effet personnel -->
        <hr />
        <div class="mt-2">
          <h4>Effets personnels</h4>
          <div class="mt-1">
            <h6>Avez-vous des effets personnels ?</h6>
            <div>
              {{
                subscription.data.personal_effects_in_building ? "Oui" : "Non"
              }}
            </div>
          </div>
        </div>
        <div>
          <div>
            <div>
              <strong>Liste détaillée des effets personnels</strong>
            </div>
            <div>
              {{
                subscription.data.description_or_list_of_effects
                  ? subscription.data.description_or_list_of_effects
                  : ""
              }}
            </div>
          </div>
          <div>
            <div><strong>Montant</strong></div>
            <div>
              {{
                subscription.data.personal_effects_amount
                  ? subscription.data.personal_effects_amount
                  : ""
              }}
            </div>
          </div>
        </div>
        <!-- Sécurité -->
        <hr />
        <div class="mt-2">
          <h4>Sécurité</h4>
          <div class="mt-1">
            <h6>Votre bâtiment est-il sécurisé ?</h6>
            <div>
              {{
                subscription.data.is_your_building_secure_bool ? "Oui" : "Non"
              }}
            </div>
          </div>
        </div>
        <div class="__first">
          <div class="mt-1">
            <div class="mt-1">
              <strong>Dispositifs sécuritaire mis en place</strong>
            </div>
            <div>
              {{
                subscription.data.is_your_building_secure.length > 0
                  ? subscription.data.is_your_building_secure.join(", ")
                  : ""
              }} {{ subscription.data.other_secure_dispositif ? ',' : '' }} {{ subscription.data.other_secure_dispositif ?? "" }}
            </div>
          </div>
          <div class="mt-1">
            <div class="mt-1">
              <strong>Dispositifs de protection contre l'incendie</strong>
            </div>
            <div>
              {{
                subscription.data.is_your_building_fire_secure.length > 0
                  ? subscription.data.is_your_building_fire_secure.join(", ")
                  : ""
              }} {{ subscription.data.other_fire_secure_dispositif ? ',' : '' }} {{ subscription.data.other_fire_secure_dispositif ?? "" }}
            </div>
          </div>
          <div class="mt-1">
            <div class="mt-1"><strong>Date du vol</strong></div>
            <div>
              {{
                subscription.data.date_of_steal
                  ? subscription.data.date_of_steal
                  : ""
              }}
            </div>
          </div>
          <div class="mt-1">
            <div class="mt-1"><strong>Circonstances du vol</strong></div>
            <div>
              {{
                subscription.data.circumstances_of_steal
                  ? subscription.data.circumstances_of_steal
                  : ""
              }}
            </div>
          </div>
          <div class="mt-1">
            <div class="mt-1">
              <strong>Informations complémentaires</strong>
            </div>
            <div>
              {{
                subscription.data.other_additional_information
                  ? subscription.data.other_additional_information
                  : ""
              }}
            </div>
          </div>
          <div class="mt-1">
            <div class="mt-1">
              <strong>Précautions prises depuis</strong>
            </div>
            <div>
              {{
                subscription.data.precautions
                  ? subscription.data.precautions
                  : ""
              }}
            </div>
          </div>
        </div>
      </div>
      <hr />
      <!-- Dommages électriques -->
      <div class="mt-2">
        <h4>Dommages électriques</h4>
        <div class="mt-1">
          <h6>Coffre-fort</h6>
          <div>
            {{
              subscription.data.safe?.length > 0 ? subscription.data.safe.join(", ") : ""
            }} {{ subscription.data.other_safe ? ',' : '' }} {{ subscription.data.other_safe ?? "" }}
          </div>
        </div>
      </div>
      <div class="__first">
        <div class="mt-1">
          <div class="mt-1">
            <strong>Marque</strong>
          </div>
          <div>
            {{ subscription.data.safe_brand ?? "" }}
          </div>
        </div>
        <div class="mt-1">
          <div class="mt-1">
            <strong>Type</strong>
          </div>
          <div>
            {{ subscription.data.safe_type ?? "" }}
          </div>
        </div>
        <div class="mt-1">
          <div class="mt-1">
            <strong>Poids</strong>
          </div>
          <div>
            {{ subscription.data.safe_weight ?? "" }}
          </div>
        </div>
        <div class="mt-1">
          <div class="mt-1">
            <strong>Année</strong>
          </div>
          <div>
            {{ subscription.data.safe_year ?? "" }}
          </div>
        </div>
        <div class="mt-1">
          <div class="mt-1">
            <strong>Le coffre est-il scellé ?</strong>
          </div>
          <div>
            {{ subscription.data.is_safe_secured ? "Oui" : "Non" }}
          </div>
        </div>
        <div class="mt-1">
          <div class="mt-1">
            <strong>Capital (Fcfa)</strong>
          </div>
          <div>
            {{ subscription.data.safe_capital ?? "" }}
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="subscription.files != null && subscription.files.length > 0"
      class="card__info mt-2"
    >
      <h4>Fichiers joints</h4>
      <div class="mt-2">
        <div class="row">
          <div
            v-for="(item, key) in subscription.files"
            :key="key"
            class="col-md-4"
          >
            <a class="file" download :href="item.url">{{ item.name }}</a>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      id="comments"
      tabindex="-1"
      role="dialog"
      aria-labelledby="comments"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-scrollable" role="document">
        <div class="modal-content">
          <div class="modal-header" style="background-color: #fff !important">
            <h5 class="modal-title" id="comments">
              Négociation de l'assurance MRH n° {{ subscription.id }}
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body" style="background-color: #f8f8f8 !important">
            <div class="chat-box">
              <div
                :class="!comment.is_customer ? 'chat' : 'chat-left'"
                class="mb-2"
                v-for="(comment, key) in comments"
                :key="key"
              >
                {{ comment.message }}
              </div>
            </div>
          </div>
          <div class="modal-footer grid-item">
            <input
              @keyup.enter="sendComment"
              :class="sending ? 'error' : ''"
              v-model="comment.message"
              type="text"
              class="form-control message"
              placeholder="Tapez votre message"
            />
            <button @click="sendComment" type="button" class="btn btn-primary">
              Envoyer
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import axios from "axios";
import { api, EventBus } from "../../../../helpers/shared";
export default {
  props: ["subscription", "user"],
  data: () => ({
    comment: {
      message: "",
      uuid: "",
      id: "",
    },
    sending: false,
    comments: [],
  }),
  mounted() {
    if (
      this.subscription.status === "negotiated" &&
      this.subscription.amount_negotiated === null
    ) {
      this.getComments();
    }
  },
  methods: {
    continousAction() {
      const url =
        "/administration/subscription/continous/" + this.subscription.uuid;
      let { uuid } = this.subscription;
      let carts = this.$storage.getItem("carts");
      let exist = false;

      if (carts) {
        let data = JSON.parse(this.$storage.decryptString(carts));
        data.forEach((el) => {
          if (el.uuid == uuid) {
            exist = true;
            return;
          }
        });
        if (exist) {
          this.$toasted.global.error({
            message: "Ce produit existe déjà dans le panier",
          });
        } else {
          window.location.href = url;
        }
      } else window.location.href = url;
    },
    addBasket() {
      let { amount, data, product_id, step, uuid } = this.subscription;
      let construct = {
        check: true,
        detail: {
          net: parseInt(amount),
          summary: [],
          total: parseInt(amount),
        },
        product: {
          amount: parseInt(amount),
          data: data,
          product_id: product_id,
          step: step,
        },
        uuid: uuid,
        uuids: uuid,
      };
      let carts = this.$storage.getItem("carts");
      let exist = false;
      if (carts) {
        let data = JSON.parse(this.$storage.decryptString(carts));
        data.forEach((el) => {
          if (el.uuids == uuid) {
            exist = true;
            return;
          }
        });
        if (exist) {
          this.$toasted.global.error({
            message: "Ce produit existe déjà dans le panier",
          });
        } else {
          data.push(construct);
          //localStorage.setItem('carts', JSON.stringify(data));
          this.$storage.setItem(
            "carts",
            this.$storage.encryptString(JSON.stringify(data))
          );
          EventBus.$emit("addBasket");
          this.$toasted.global.all({
            message: "Le produit est ajouté au panier",
          });
        }
      } else {
        this.$storage.setItem(
          "carts",
          this.$storage.encryptString(
            JSON.stringify([
              {
                product: construct.product,
                detail: construct.detail,
                check: true,
                uuids: uuid,
                uuid: uuid,
              },
            ])
          )
        );
        EventBus.$emit("addBasket");
        this.$toasted.global.all({
          message: "Le produit est ajouté au panier",
        });
      }
    },

    formatDate(date) {
      return moment(date).format("DD-MM-YYYY");
    },
    sendComment() {
      if (this.comment.message != "") {
        this.sending = false;
        this.comment.uuid = this.subscription.uuid;
        this.comment.id = this.subscription.id;
        axios.post(api("subscription/add/message"), this.comment);
        this.comment.message = "";
      } else this.sending = true;
    },
    getComments() {
      db.collection(this.subscription.uuid)
        .orderBy("createdAt")
        .onSnapshot((querySnapshot) => {
          let comments = [];
          querySnapshot.forEach((doc) => {
            comments.push(doc.data());
          });
          this.comments = comments;
        });
    },
    showComments() {
      this.$document("#comments").modal("show");
    },
    back() {
      window.history.back();
    },
  },
};
</script>

<style lang="scss" scoped>
.header__title {
  font-size: 22px;
  line-height: 30px;
  color: #5e5873;
}
.back {
  cursor: pointer;
}
.top__header {
  display: grid;
  grid-template-columns: 30px 1fr 2fr;
  .header__btn {
    justify-self: end;
  }
}
.card__info {
  padding: 20px;
  height: auto;
  background: #ffffff;
  box-shadow: 0px 4px 24px rgba(0, 0, 0, 0.12);
  border-radius: 6px;
  margin-top: 20px;
  .__first {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
  }
}
.btn-secondary {
  color: #fff;
  background-color: #d09a12 !important;
  border-color: #d09a12 !important;
}

.btn-secondary:hover {
  color: #fff;
  background-color: #d09a12 !important;
  border-color: #d09a12 !important;
}

.btn-secondary:focus,
.btn-secondary.focus {
  color: #fff;
  background-color: #d09a12 !important;
  border-color: #d09a12 !important;
  box-shadow: 0 0 0 0.2rem #d09a12 !important;
}

.btn-secondary.disabled,
.btn-secondary:disabled {
  color: #fff;
  background-color: #d09a12 !important;
  border-color: #d09a12 !important;
}

.btn-secondary:not(:disabled):not(.disabled):active,
.btn-secondary:not(:disabled):not(.disabled).active,
.show > .btn-secondary.dropdown-toggle {
  color: #fff;
  background-color: #d09a12 !important;
  border-color: #d09a12 !important;
}

.btn-secondary:not(:disabled):not(.disabled):active:focus,
.btn-secondary:not(:disabled):not(.disabled).active:focus,
.show > .btn-secondary.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem #d09a12 !important;
}
.grid-item {
  display: grid;
  grid-template-columns: 3fr 1fr;
  grid-gap: 5px;
  padding: 5px;
}
.chat {
  background-color: #fff;
  padding: 10px;
  height: auto;
  width: 80%;
  border-radius: 5px;
}
.chat-left {
  background: linear-gradient(
    46.62deg,
    #001e5f 0%,
    rgba(0, 30, 95, 0.8) 93.64%
  );
  border-radius: 5px;
  color: #fff;
  text-align: right;
  padding: 10px;
  height: auto;
  width: 80%;
  margin-left: 20%;
}
.error {
  border-color: red !important;
}
.file {
  text-decoration: none;
  color: #6e6b7b;
}
</style>
